module.exports = __webpack_public_path__ + "static/img/front_end_develop.db77675.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource_10_23/front_end_develop.jpg
// module id = Hu4a
// module chunks = 1